import {Howl, Howler} from 'howler';
import {isLocalStorageAvailable} from "../utilites";
import {isMobile} from "pixi.js";

let isSoundOff = isLocalStorageAvailable() ? localStorage.getItem('isSoundOff') === 'true': false;
Howler.mute(isSoundOff);

export const coinSound = new Howl({src: ["./audio/coin.mp3"]});

export const emptyBoxSound = new Howl({src: ["./audio/empty-box.mp3"]});

export const explosionSound = new Howl({src: ["./audio/explosion.mp3"]});

export const reelStopSound = new Howl({src: ["./audio/reel-stop.mp3"]});

export const scatterSound = new Howl({src: ["./audio/scatter.mp3"]});

export const rocketExplosionSound = new Howl({src: ["./audio/rocket-explosion.mp3"]});

export const rocketLaunchSound = new Howl({src: ["./audio/rocket-launch.mp3"]});

export const backgroundSound = new Howl({
    src: ["./audio/bg.mp3"],
    loop: true,
    volume: isMobile.phone ? 0.32 : 0.2,
});

backgroundSound.pause();
backgroundSound.play();
